import React, { createContext, useCallback, useContext, useState } from 'react';
import { t as tHelper, DEFAULT_LANG, LANGUAGES } from './index';

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        const stored = localStorage.getItem('lang');
        return stored && LANGUAGES[stored] ? stored : DEFAULT_LANG;
    });

    const setLang = useCallback((code) => {
        if (!LANGUAGES[code]) return;
        localStorage.setItem('lang', code);
        setLangState(code);
    }, []);

    const t = useCallback((key) => tHelper(key, lang), [lang]);

    return (
        <LangContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LangContext.Provider>
    );
};

export const useLanguage = () => {
    const ctx = useContext(LangContext);
    if (!ctx) throw new Error('useLanguage must be used within a LangProvider');
    return ctx;
};
